import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const UniversalLogin = () => {
  const [activeTab, setActiveTab] = useState('student');
  const [studentData, setStudentData] = useState({
    usn: '',
    password: ''
  });
  
  const [facultyData, setFacultyData] = useState({
    email: '',
    password: ''
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleStudentChange = (e) => {
    setStudentData({ ...studentData, [e.target.name]: e.target.value });
  };

  const handleFacultyChange = (e) => {
    setFacultyData({ ...facultyData, [e.target.name]: e.target.value });
  };

  const handleStudentSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      console.log('Student login attempt with USN:', studentData.usn.toUpperCase());

      const response = await api.post('/auth/login', {
        usn: studentData.usn.toUpperCase(),
        password: studentData.password,
        role: 'student'
      });

      console.log('Login response:', response.data);

      // Save to localStorage
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('usn', response.data.user.usn);
      localStorage.setItem('userId', response.data.user._id);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('userRole', 'student');

      alert('✅ Login successful!');
      navigate('/student-dashboard');
    } catch (error) {
      console.error('Student login error:', error);
      setError(error.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleFacultySubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      console.log('Faculty login attempt with email:', facultyData.email);

      const response = await api.post('/auth/login', {
        email: facultyData.email.toLowerCase(),
        password: facultyData.password,
        role: 'faculty'
      });

      console.log('Faculty login response:', response.data);

      // Save to localStorage
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userId', response.data.user._id);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('userRole', 'faculty');

      alert('✅ Faculty login successful!');
      navigate('/faculty-dashboard');
    } catch (error) {
      console.error('Faculty login error:', error);
      setError(error.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.formCard}>
        <h2 style={styles.title}>🔐 Login Portal</h2>
        
        {/* Tab Buttons */}
        <div style={styles.tabContainer}>
          <button
            onClick={() => setActiveTab('student')}
            style={activeTab === 'student' ? styles.activeTab : styles.tab}
          >
            Student
          </button>
          <button
            onClick={() => setActiveTab('faculty')}
            style={activeTab === 'faculty' ? styles.activeTab : styles.tab}
          >
            Faculty
          </button>
        </div>

        {error && <div style={styles.error}>{error}</div>}

        {/* Student Login Form */}
        {activeTab === 'student' && (
          <form onSubmit={handleStudentSubmit} style={styles.form}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>USN *</label>
              <input
                type="text"
                name="usn"
                value={studentData.usn}
                onChange={handleStudentChange}
                style={styles.input}
                placeholder="Enter your USN (e.g., 4SF22CS061)"
                required
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Password *</label>
              <input
                type="password"
                name="password"
                value={studentData.password}
                onChange={handleStudentChange}
                style={styles.input}
                placeholder="Enter your password"
                required
              />
            </div>

            <button type="submit" style={styles.submitButton} disabled={loading}>
              {loading ? 'Logging in...' : 'Login as Student'}
            </button>
          </form>
        )}

        {/* Faculty Login Form */}
        {activeTab === 'faculty' && (
          <form onSubmit={handleFacultySubmit} style={styles.form}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Email *</label>
              <input
                type="email"
                name="email"
                value={facultyData.email}
                onChange={handleFacultyChange}
                style={styles.input}
                placeholder="Enter your email"
                required
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Password *</label>
              <input
                type="password"
                name="password"
                value={facultyData.password}
                onChange={handleFacultyChange}
                style={styles.input}
                placeholder="Enter your password"
                required
              />
            </div>

            <button type="submit" style={styles.submitButton} disabled={loading}>
              {loading ? 'Logging in...' : 'Login as Faculty'}
            </button>
          </form>
        )}

        <div style={styles.footer}>
          <p style={styles.footerText}>
            Don't have an account? 
            {activeTab === 'student' ? (
              <a href="/student-registration" style={styles.link}> Register as Student</a>
            ) : (
              <a href="/faculty-signup" style={styles.link}> Register as Faculty</a>
            )}
          </p>
          <p style={styles.footerText}>
            <a href="/" style={styles.link}>← Back to Home</a>
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
  },
  formCard: {
    background: 'white',
    borderRadius: '20px',
    padding: '3rem',
    maxWidth: '500px',
    width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  title: {
    textAlign: 'center',
    fontSize: '2.5rem',
    color: '#333',
    marginBottom: '2rem',
  },
  tabContainer: {
    display: 'flex',
    gap: '1rem',
    marginBottom: '2rem',
  },
  tab: {
    flex: 1,
    padding: '1rem',
    background: '#f7fafc',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600',
    transition: 'all 0.3s ease',
  },
  activeTab: {
    flex: 1,
    padding: '1rem',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600',
  },
  error: {
    background: '#fee',
    color: '#c33',
    padding: '1rem',
    borderRadius: '10px',
    marginBottom: '1.5rem',
    textAlign: 'center',
    fontWeight: '600',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#555',
    marginBottom: '0.5rem',
  },
  input: {
    padding: '0.9rem 1rem',
    border: '2px solid #ddd',
    borderRadius: '10px',
    fontSize: '1rem',
    outline: 'none',
    transition: 'border 0.3s ease',
  },
  submitButton: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    padding: '1rem',
    borderRadius: '10px',
    fontSize: '1.1rem',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '1rem',
    transition: 'transform 0.2s ease',
  },
  footer: {
    marginTop: '2rem',
    textAlign: 'center',
  },
  footerText: {
    color: '#666',
    margin: '0.5rem 0',
  },
  link: {
    color: '#667eea',
    textDecoration: 'none',
    fontWeight: '600',
  },
};

export default UniversalLogin;
